import styled from "styled-components";
import { RightArrow } from "@/assets/Icons/RightArrow";
import { Heading } from "@/components/UtilityComponents/Heading";
import { CenterWrapper } from "@/components/UtilityComponents/styled";
import { ProductBasicInfoFragment } from "@/generated/graphql";
import { PrimaryButton } from "@/components/Button";
import { rtl } from "@/shared/styles-utils";
import { Section } from "@/shared/layout";
import { FormattedMessage } from "@/i18n/i18n-client";
import { Link } from "@/i18n/i18n-navigation";
import ProductsList from "../elements/ProductsList";

interface ProductsSectionFallbackProps {
  products: ProductBasicInfoFragment[];
}

const ProductsSectionFallback = ({
  products,
}: ProductsSectionFallbackProps) => {
  return (
    <Section>
      <Heading>
        <FormattedMessage defaultMessage="Our Products" id="p98kOH" />
      </Heading>
      <ProductsList products={products} />
      <CenterWrapper>
        <Link href={"/shop"} passHref>
          <ProductButton suffixIcon={<RightArrow />}>
            <FormattedMessage
              defaultMessage="See more from Our Products"
              id="4eN/uR"
            />
          </ProductButton>
        </Link>
      </CenterWrapper>
    </Section>
  );
};

export default ProductsSectionFallback;

const ProductButton = styled(PrimaryButton)`
  padding: 14px 32px;
  span {
    padding: 0 5px;
  }
  div {
    padding: 0 5px;
  }
  svg {
    ${rtl("transform: rotate(180deg)", "transform: rotate(0deg)")}
  }
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;
